import { createSelector } from 'reselect';

import { MyAccountRootState } from '../MyAccountRootState';

import { OWNER_DOMAIN_KEY } from './constants';

export const ownerState = (state: MyAccountRootState) =>
  state[OWNER_DOMAIN_KEY];

export const fullProducts = createSelector([ownerState], (state) =>
  state.get('fullProducts'),
);
